"use client";

import React from "react";
import Form from "@sendsprint/ui-react/components/form";
import Button from "@sendsprint/ui-react/components/button";
import FormField from "@sendsprint/ui-react/components/formInput";
import Box from "@sendsprint/ui-react/components/box";
import EmailOutline from "@sendsprint/icons/svgs/EmailOutline";
import PersonOutline from "@sendsprint/icons/svgs/PersonOutline";
import { UseMailingListResponse } from "../../hooks/useMailingList";

export interface IMailingForm {
  name: string;
  email: string;
}

const initialValues: IMailingForm = { name: "", email: "" };

interface Props {
  mailingLogic: UseMailingListResponse;
  background?: "deep-green" | "light-green";
  isNewsletterPage?: boolean;
}

const MailingListForm = ({
  mailingLogic,
  background,
  isNewsletterPage,
}: Props) => {
  const { handleSubmit, isPending, validationSchema } = mailingLogic;

  return (
    <Form
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <Box className="ss:flex ss:items-start ss:gap-4 ss:flex-col">
        <Box className="ss:w-full">
          <FormField
            icon={PersonOutline}
            name="name"
            label={isNewsletterPage ? "Your name" : "Enter your name"}
          />
        </Box>
        <Box className="ss:w-full">
          <FormField
            name="email"
            icon={EmailOutline}
            type="email"
            label={isNewsletterPage ? "Your email" : "Enter your email address"}
          />
        </Box>
        <Box className="ss:w-full ss:relative">
          <Button
            type="submit"
            label={isNewsletterPage ? "Join community" : "Join list"}
            loading={isPending}
            fullWidth
            data-testid="mailing-form-submit-btn"
            variant={
              isNewsletterPage
                ? "primary"
                : background === "deep-green"
                  ? "secondary"
                  : "primary"
            }
          />
        </Box>
      </Box>
    </Form>
  );
};

export default MailingListForm;
